import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from '../authentication/components/ProtectedRoute';
import OrganizationsPage from '../organizations/pages/OrganizationPage';
import OrganizationEditPage from '../organizations/pages/OrganizationEditPage';
import SubscriptionsPage from '../subscriptions/pages/SubscriptionPage';
import SubscriptionDetailsPage from '../subscriptions/pages/SubscriptionDetailsPage';
import React from 'react';

export const ResalePartnerRoutes = () => (
  <>
    <Route
      path="/organizations"
      element={
        <ProtectedRoute>
          <OrganizationsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/organizations/edit/:id"
      element={
        <ProtectedRoute>
          <OrganizationEditPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/subscriptions"
      element={
        <ProtectedRoute>
          <SubscriptionsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/subscriptions/details/:id"
      element={
        <ProtectedRoute>
          <SubscriptionDetailsPage />
        </ProtectedRoute>
      }
    />
  </>
);
